import '../../css/app.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vSelect from 'vue3-select'

import App from './App.vue'
import router from './router'
import axios from '@/axios'
import familyCrestUrl from '@/assets/family_crest.webp'

const positionSelectDropdown = (dropdown, component) => {
  const updatePosition = () => {
    const toggle = component.$refs.toggle
    if (!toggle) return

    const toggleRect = toggle.getBoundingClientRect()
    const dropdownHeight = dropdown.getBoundingClientRect().height
    const opensAbove = toggleRect.bottom + dropdownHeight > window.innerHeight

    dropdown.style.position = 'fixed'
    dropdown.style.left = `${toggleRect.left}px`
    dropdown.style.top = opensAbove
      ? `${Math.max(0, toggleRect.top - dropdownHeight)}px`
      : `${toggleRect.bottom}px`
    dropdown.style.bottom = 'auto'
    dropdown.style.width = `${toggleRect.width}px`
  }

  updatePosition()
  window.addEventListener('resize', updatePosition)
  window.addEventListener('scroll', updatePosition, true)

  return () => {
    window.removeEventListener('resize', updatePosition)
    window.removeEventListener('scroll', updatePosition, true)
  }
}

// Mount every vue-select menu outside scrollable modals without changing its input.
vSelect.props.appendToBody.default = true
vSelect.props.calculatePosition.default = positionSelectDropdown

const familyName = import.meta.env.VITE_APP_NAME?.trim()

if (familyName && !familyName.startsWith('$')) {
  document.title = `${familyName} Family Website`
}

const favicon = document.querySelector('link[rel="icon"]')
if (favicon) favicon.href = familyCrestUrl

;(async () => {
  try {
    await axios.get('/api/auth/csrf')
  } catch (e) {
    console.warn('CSRF bootstrap failed', e)
  }

  const app = createApp(App)

  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)

  app.use(pinia)
  app.use(router)
  app.mount('#app')
})()
